var map = {
	"./apple-music.svg": 413,
	"./artist-card-overlay-green.svg": 414,
	"./cookie.svg": 247,
	"./facebook.svg": 415,
	"./instagram.svg": 416,
	"./overlayvideo.svg": 283,
	"./sponsor.svg": 248,
	"./spotify.svg": 417,
	"./tiktok.svg": 418,
	"./twitter.svg": 419,
	"./website.svg": 420,
	"./x-pattern-overlay.svg": 421,
	"./youtube.svg": 422
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 412;